import { ConfigProvider } from 'antd';
import React from 'react';
import { render } from 'react-dom';
import { register } from './boot/serviceWorker';
import Routes from './components/routes';
import './index.less';
import './boot/axios';

function Index() {
  return (
    <ConfigProvider locale={{ locale: 'zh-CN' }}>
      <Routes />
    </ConfigProvider>
  );
}

render(<Index />, document.querySelector('#root'));

register();
